export const shouldLoad = () => document.querySelector('[data-controller="horizontal-chip-filter-priority"]') !== undefined;
